// extracted by mini-css-extract-plugin
export default {"container":"MissionChoice_container__RgkAg","option":"MissionChoice_option__d1H2y"};